module.exports = __webpack_public_path__ + "static/media/poc-logoTableSpade.d2ace1b1.svg";